module.exports = __webpack_public_path__ + "static/media/assignmentConfig.2089f350.svg";